import React, { useEffect, useState } from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "axios";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import Swal from "sweetalert2";

const Deliverynoteinward_new = () => {
  useAuthRedirect();
  const { delNo } = useParams();

  const [headerDetails, setHeaderDetails] = useState({});
  const [itemDetails, setItemDetails] = useState([]);
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDetails = async () => {
      if (!delNo) {
        console.log("No Delivery Note Number (delNo) provided");
        return;
      }
      try {
        setLoading(true);
        console.log(`Fetching details for Delivery Note No: ${delNo}`);
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/deliveryNote_detail?delNo=${delNo}`
        );

        if (response.data && response.data.deliveryDetail?.length > 0) {
          const items = response.data.deliveryDetail;

          const header = {
            del_no: items[0].del_no,
            del_id: items[0].del_id,
            frombranch: items[0].frombranch,
            tobranch: items[0].tobranch,
            del_send: items[0].del_send,
            del_date: items[0].del_date,
          };

          setHeaderDetails(header);
          setItemDetails(items);

          setFormData(
            items.map((item) => ({
              del_no: item.del_no,
              del_id: item.del_id,
              del_description: item.del_description || "",
              recQty: "",
              balQty: item.Del_Qty, // default = full balance
            }))
          );
        } else {
          console.warn("API Response does not contain expected data structure");
          setItemDetails([]);
        }
      } catch (error) {
        console.error("Error fetching delivery details:", error);
        setItemDetails([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [delNo]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;

    if (name === "recQty") {
      const deliveryQty = Number(itemDetails[index]?.Del_Qty || 0);
      const recQty = Number(value);

      // ✅ Validation checks
      if (isNaN(recQty)) {
        Swal.fire("Error", "Accepted Quantity must be a number", "error");
        return;
      }
      if (recQty < 0) {
        Swal.fire("Error", "Accepted Quantity cannot be negative", "error");
        return;
      }
      if (recQty > deliveryQty) {
        Swal.fire(
          "Error",
          `Accepted Quantity cannot be greater than Delivery Quantity (${deliveryQty})`,
          "error"
        );
        return;
      }

      const balQty = deliveryQty - recQty;

      setFormData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = {
          ...updatedData[index],
          recQty: recQty,
          balQty: balQty,
        };
        return updatedData;
      });
    } else {
      setFormData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = {
          ...updatedData[index],
          [name]: value,
        };
        return updatedData;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
                 Swal.fire({
                            title: "Submitting...",
                            text: "Please wait while we process your request.",
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            },
                        });
        
      const response = await axios.put(
        "https://rfs2.infraconsoft.net.in/api/inward_update",
        { items: formData },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log("Response:", response.data);
      Swal.fire("Success", "Data updated successfully!", "success");
      navigate("/inventory/deliveryinwardnote_in");
    } catch (error) {
      console.error(
        "Error submitting form:",
        error.response?.data || error.message
      );
      Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
  };

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Delivery Note Details</h2>
            <Link to="/inventory/deliveryinwardnote_in">
              <p className="back-button">
                <i className="fa-solid fa-backward"></i>Back
              </p>
            </Link>
          </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Del No :</label>
                <input type="text" value={delNo} readOnly />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
                  type="text"
                  value={
                    headerDetails?.del_date
                      ? new Date(headerDetails.del_date).toLocaleDateString(
                          "en-GB"
                        )
                      : ""
                  }
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>From Branch :</label>
                <input
                  type="text"
                  value={headerDetails?.frombranch}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>To Branch :</label>
                <input type="text" value={headerDetails?.tobranch} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Send Through :</label>
                <input type="text" value={headerDetails?.del_send} readOnly />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>

            <table className="items-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Descriptions</th>
                  <th>Del.Qty</th>
                  <th>Accepted Qty</th>
                  <th>Rejected Qty</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="6"
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Please wait...
                    </td>
                  </tr>
                ) : itemDetails.length > 0 ? (
                  itemDetails.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.del_description}</td>
                      <td>{item.Del_Qty}</td>
                      <td>
                        <input
                          type="text"
                          name="recQty"
                          value={formData[index]?.recQty || ""}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          name="balQty"
                          value={formData[index]?.balQty || ""}
                          readOnly
                        />
                      </td>
                      <td>{item.del_remarks || "N/A"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Deliverynoteinward_new;
